import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

import { GroupsEvent } from '../GroupsEvent';

export class GroupWasDeleted extends GroupsEvent {
  process() {
    const { groupId } = this.eventPayload;

    const group = Entities.GroupsStore.getGroupById(groupId.toString());
    if (!group) {
      return;
    }

    let alert = t('common_chat_is_not_accessible');

    if (group.isChannel) {
      alert = t('common_channel_is_not_accessible');
    }

    Tasks.group.removeGroupLocally({
      groupId,
      alert,
    });
  }
}
